import { Injectable } from '@angular/core';

@Injectable()
export class AdminSearchService {

  constructor() { }


  /** This function returns matches on the array passed in as a param
   * 
   * @param searchField: string[] -- a the properties of the objects to search on
   * @param query -- the query
   * @param data -- the array to filter
  */
  public static search(searchField: string[], query: string, data: any[]): any[] {
    console.log(searchField, query, data);

    const items = data.map(i => {
      let text = [];
      searchField.forEach((key) => {
        if (key.includes('.') !== true) {
          text.push(i[key]);
      
        } else {
          const objkeys = key.split('.');
          console.log(objkeys,i);
          if (i.hasOwnProperty(objkeys[0])) {
            if (i[objkeys[0]].hasOwnProperty(objkeys[1])) {
              text.push(i[objkeys[0]][objkeys[1]]);
            }
          }
        }
      });



      return {
        data: i,
        text: text.join(' ').toLowerCase()
      };
    });

    const keywords = query.toLowerCase().split(' ');



    const matches = items.filter(i => {
      const m = keywords.filter(k => i.text.includes(k));
      return m.length === keywords.length;
    });

    return matches.map(m => m.data);


  }
}

